/* Ingredient carousel — center-active swipe, scoped to .lust-final2706-single (MKT 2026-07-10) */
(function () {
  'use strict';
  var root = document.querySelector('.lust-final2706-single');
  if (!root) return;

  var track = root.querySelector('#ingCarousel');
  if (!track) return;
  var slides = [].slice.call(track.querySelectorAll('.ing-slide'));
  if (!slides.length) return;
  var prev = root.querySelector('#ingPrev');
  var next = root.querySelector('#ingNext');

  function step() {
    var s = track.querySelector('.ing-slide');
    return s ? s.getBoundingClientRect().width + 16 : 300;
  }

  function update() {
    var center = track.getBoundingClientRect().left + track.clientWidth / 2;
    var closest = null, dist = Infinity;
    slides.forEach(function (s) {
      var r = s.getBoundingClientRect();
      var d = Math.abs((r.left + r.width / 2) - center);
      if (d < dist) { dist = d; closest = s; }
    });
    slides.forEach(function (s) { s.classList.toggle('active', s === closest); });
  }

  var raf = null;
  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; update(); });
  }

  track.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

  setTimeout(update, 60);
}());
